var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.544,
    height: 48.922,
    viewBox: "0 0 54.544 48.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ebbc02;\n      }\n\n      .cls-2 {\n        filter: url(#Trac\xE9_3007);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_3007",
    x: 0,
    y: 0,
    width: 54.544,
    height: 48.922,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-calendar",
    "data-name": "Icon ionic-ios-calendar",
    transform: "translate(5.625 -1.311)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2",
    transform: "matrix(1, 0, 0, 1, -5.63, 1.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3007-2",
    "data-name": "Trac\\xE9 3007",
    className: "cls-1",
    d: "M36.405,6.75H32.891V8.858a.7.7,0,0,1-.7.7H30.783a.7.7,0,0,1-.7-.7V6.75H13.214V8.858a.7.7,0,0,1-.7.7H11.105a.7.7,0,0,1-.7-.7V6.75H6.889a3.524,3.524,0,0,0-3.514,3.514V34.158a3.524,3.524,0,0,0,3.514,3.514H36.405a3.524,3.524,0,0,0,3.514-3.514V10.264A3.524,3.524,0,0,0,36.405,6.75Zm.7,26.354a1.762,1.762,0,0,1-1.757,1.757H7.943A1.762,1.762,0,0,1,6.186,33.1V17.292a.7.7,0,0,1,.7-.7H36.405a.7.7,0,0,1,.7.7Z",
    transform: "translate(5.63 -0.75)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3008",
    "data-name": "Trac\\xE9 3008",
    className: "cls-1",
    d: "M11.811,5.2a.7.7,0,0,0-.7-.7H9.7a.7.7,0,0,0-.7.7V7.311h2.811Z",
    transform: "translate(1.403)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3009",
    "data-name": "Trac\\xE9 3009",
    className: "cls-1",
    d: "M27.561,5.2a.7.7,0,0,0-.7-.7H25.453a.7.7,0,0,0-.7.7V7.311h2.811Z",
    transform: "translate(5.33)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon_calendar.fe7bc2a0d6645a0e4b432465e80953ca.svg";
export { ForwardRef as ReactComponent };